import { render, staticRenderFns } from "./Topo.vue?vue&type=template&id=04074949"
import script from "./Topo.vue?vue&type=script&lang=js"
export * from "./Topo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports